import toast from 'react-hot-toast';

export const showToaster = (type, message, duration = 4000, toastId) => {
  const options = {
    duration,
    id: toastId,
  };

  switch (type) {
    case 'success':
      return toast.success(message, options);
    case 'error':
      return toast.error(message, options);
    case 'loading':
      return toast.loading(message, { id: toastId });
    default:
      return toast(message, options);
  }
};

export const dismissToaster = (toastId) => {
  toast.dismiss(toastId);
};

export const updateToaster = (toastId, type, message) => {
    if (type === 'success') {
        toast.success(message, { id: toastId });
    } else if (type === 'error') {
        toast.error(message, { id: toastId });
    }
};
